import { render, staticRenderFns } from "./AllowPermission.vue?vue&type=template&id=7eb9ad04"
import script from "./AllowPermission.vue?vue&type=script&lang=js"
export * from "./AllowPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports